import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('custom-service-worker.js')
    .then((reg) => console.log('✅ Custom Service Worker registrado', reg))
    .catch((err) => console.error('❌ Error al registrar el Service Worker', err));
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
